var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SellerChurnParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { SolutionType } from '../solutionType';
import { SolutionParams } from './solutionParams';
import { sellerChurnParamsSchemaValidation } from '../../validations.generated';
export var SellerChurnParamNames;
(function (SellerChurnParamNames) {
    SellerChurnParamNames["DataSourceID"] = "dataSourceID";
    SellerChurnParamNames["SellerColumn"] = "sellerColumn";
    SellerChurnParamNames["ChurnColumn"] = "churnColumn";
    SellerChurnParamNames["ChurnValueType"] = "churnValueType";
    SellerChurnParamNames["ChurnValue"] = "churnValue";
    SellerChurnParamNames["PerformanceColumn"] = "performanceColumn";
})(SellerChurnParamNames || (SellerChurnParamNames = {}));
export const sellerChurnParamsSchema = {
    $id: 'urn:wisepipe-solution-domain:SellerChurnParams',
    type: 'object',
    properties: {
        sellerColumn: { type: 'string', minLength: 1 },
        churnColumn: { type: 'string', minLength: 1 },
        churnValue: { type: 'string', minLength: 1 },
        performanceColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
let SellerChurnParams = SellerChurnParams_1 = class SellerChurnParams extends SolutionParams {
    constructor(sellerColumn, churnColumn, churnValue, performanceColumn) {
        super(SolutionType.SellerChurn);
        this.sellerColumn = sellerColumn;
        this.churnColumn = churnColumn;
        this.churnValue = churnValue;
        this.performanceColumn = performanceColumn;
        JSON.validate(this, SellerChurnParams_1);
    }
    toTemplateParams(dataSource) {
        if (!this.sellerColumn)
            throw new Error('Values for all churn parameters must be provided; value for "sellerColumn" missing.');
        if (!this.churnColumn)
            throw new Error('Values for all churn parameters must be provided; value for "churnColumn" missing.');
        if (!this.churnValue)
            throw new Error('Values for all churn parameters must be provided; value for "churnValue" missing.');
        if (!this.performanceColumn)
            throw new Error('Values for all churn parameters must be provided; value for "performanceColumn" missing.');
        // Make sure columns exist in the datasource
        if (!dataSource.columns)
            throw new Error(`No columns found in data source ${dataSource.dataSourceID}`);
        if (!dataSource.columns.find((c) => c.name === this.sellerColumn))
            throw new Error(`Column "${this.sellerColumn}" not found in data source ${dataSource.dataSourceID}`);
        if (!dataSource.columns.find((c) => c.name === this.churnColumn))
            throw new Error(`Column "${this.churnColumn}" not found in data source ${dataSource.dataSourceID}`);
        if (!dataSource.columns.find((c) => c.name === this.performanceColumn))
            throw new Error(`Column "${this.performanceColumn}" not found in data source ${dataSource.dataSourceID}`);
        const churnColumn = dataSource.columns.find((c) => c.name === this.churnColumn);
        const params = new Map();
        params.set(SellerChurnParamNames.DataSourceID, dataSource.dataSourceID);
        params.set(SellerChurnParamNames.SellerColumn, this.sellerColumn);
        params.set(SellerChurnParamNames.ChurnColumn, this.churnColumn);
        params.set(SellerChurnParamNames.ChurnValueType, churnColumn.type);
        params.set(SellerChurnParamNames.ChurnValue, this.churnValue);
        params.set(SellerChurnParamNames.PerformanceColumn, this.performanceColumn);
        return params;
    }
    get allParams() {
        return [
            SellerChurnParamNames.SellerColumn,
            SellerChurnParamNames.ChurnColumn,
            SellerChurnParamNames.ChurnValue,
            SellerChurnParamNames.PerformanceColumn
        ];
    }
    get size() {
        return SellerChurnParams_1.size();
    }
    static size() {
        return 4;
    }
};
SellerChurnParams = SellerChurnParams_1 = __decorate([
    JsonSchemaV2(sellerChurnParamsSchema, sellerChurnParamsSchemaValidation),
    JsonDiscriminatorValue(SolutionType.SellerChurn)
], SellerChurnParams);
export { SellerChurnParams };
//# sourceMappingURL=sellerChurnParams.js.map